import Pane from '@opsbase/web-layout/Pane';
import React, { useContext } from 'react';
import { HashLink } from 'react-router-hash-link';
import useReportCSS from '../../useReportCSS';
import DetailsReportConversation from '../DetailsReportConversation';
import DetailsOpReportContext from './DetailsOpReportContext';
export function DetailsOpReportConversations() {
    const { op, def, notes } = useContext(DetailsOpReportContext);
    const myCss = useReportCSS(def.pdf);
    return (React.createElement(React.Fragment, null, notes.map((conversation, idx) => {
        var _a;
        return (React.createElement("div", { key: 'conversation' + idx, className: myCss.page2 },
            React.createElement(Pane, null,
                React.createElement("div", { id: 'Note_' + (idx + 1), className: myCss.heading1 },
                    React.createElement("span", null,
                        "Note #",
                        idx + 1,
                        " "),
                    React.createElement(HashLink, { style: { fontSize: 'xx-small', textTransform: 'none' }, smooth: true, to: '#note' + (idx + 1) + '_home' }, 'Back')),
                React.createElement(DetailsReportConversation, { conversation: conversation, activity: [], timezone: (_a = op.place) === null || _a === void 0 ? void 0 : _a.timezone }))));
    })));
}
export default DetailsOpReportConversations;
